<template>
  <div>
    <div v-if="agendamentos.length" style="margin: 2rem 0">
      <div
        class="btn-group"
        role="group"
        style="display: flex; justify-content: center"
      >
        <select
          v-model="guiaAberta"
          data-test-id="select-guiaaberta"
          style="
            padding: 0 12px;
            font-size: large;
            color: white;
            background-color: #008080;
            border: none;
          "
          @change="abrirGuia"
        >
          <option v-for="guia in guias" :key="guia._id" :value="guia">
            {{ guia.autorizacao.numeroGuia }}
          </option>
        </select>
        <button
          v-if="agendamentos.length > maximoDePaginas"
          type="button"
          class="btn btn-primary"
          :disabled="paginaInicial <= 0"
          @click="paginaInicial--"
        >
          <span class="fa fa-chevron-left"></span>
        </button>
        <button
          v-for="a in agendamentosPagina"
          :key="a._id"
          type="button"
          class="btn btn-primary"
          :class="{
            active: agendamentoAberto && a._id === agendamentoAberto._id,
          }"
          @click="abrirSessao(a)"
        >
          <div style="color: #ecf0f1; text-transform: uppercase">
            {{ moment(a.data).format('MMM, D ddd') }}
          </div>
          <div style="font-weight: 600">
            {{ a.hora }}
          </div>
        </button>
        <button
          v-if="agendamentos.length > maximoDePaginas"
          type="button"
          class="btn btn-primary"
          :disabled="paginaInicial + maximoDePaginas >= agendamentos.length"
          @click="paginaInicial++"
        >
          <span class="fa fa-chevron-right"></span>
        </button>
      </div>
    </div>

    <div v-if="agendamentoAberto && agendamentoAbertoAvaliacao" class="botoes">
      <button
        id="botaoSalvarVoltar"
        data-test-id="button-botaosalvarvoltar"
        type="button"
        class="btn btn-primary"
        style="display: flex; gap: 4px; align-items: center"
        @click="salvarVoltarAgendamento()"
      >
        <span class="fa fa-arrow-left"></span>
        <span class="fa fa-save"></span>
        Salvar e ir para agendamento
      </button>
      <button
        id="botaoSalvar"
        data-test-id="button-botaosalvar"
        type="button"
        class="btn btn-primary"
        @click="salvar()"
      >
        <span class="fa fa-save"></span> Salvar
      </button>
    </div>

    <div v-if="agendamentoAberto && !agendamentoAbertoAvaliacao" class="botoes">
      <button
        id="botaoVoltar"
        data-test-id="button-botaovoltar"
        type="button"
        class="btn btn-primary"
        style="display: flex; gap: 4px; align-items: center"
        @click="voltarAgendamento()"
      >
        <span class="fa fa-arrow-left"></span>
        Ir para agendamento
      </button>
      <button
        id="botaoAdicionarDiario"
        data-test-id="button-botaoadicionardiario"
        type="button"
        class="btn btn-primary"
        @click="abrirDiarioModal()"
      >
        <span class="fa fa-plus"></span> Adicionar diário
      </button>
    </div>

    <div
      v-if="agendamentoAberto && agendamentoAbertoAvaliacao"
      class="prontuario-respostas"
    >
      <div
        v-for="(respostaRow, i) in respostas"
        :key="i"
        class="prontuario-respostas-grupo"
      >
        <div
          v-for="(resposta, j) in respostaRow"
          :key="resposta.questao._id"
          class="prontuario-resposta"
          @mouseenter="respostaHover = `${i}_${j}`"
        >
          <SelecionarMultiploDominio
            v-if="resposta.questao.tipo === 'Domínio'"
            :id="resposta.questao._id"
            :label="resposta.questao.enunciado"
            :label-sup="resposta.questao.obrigatorio ? '*' : ''"
            :dominio="resposta.questao.dominio"
            :mostrar-todos="false"
            :valor="resposta.resposta"
            @atualizar="aoAtualizarResposta(resposta, $event)"
          />
          <SelecionarData
            v-else-if="resposta.questao.tipo === 'Data'"
            :id="resposta.questao._id"
            :label="resposta.questao.enunciado"
            :label-sup="resposta.questao.obrigatorio ? '*' : ''"
            :valor="resposta.resposta"
            @atualizar="aoAtualizarResposta(resposta, $event)"
          />
          <CampoGenerico
            v-else-if="resposta.questao.tipo === 'Fracionário'"
            :id="resposta.questao._id"
            :label="resposta.questao.enunciado"
            mascara="money"
            :valor="resposta.resposta"
            @blur="aoAtualizarResposta(resposta, $event)"
          />
          <CampoGenerico
            v-else-if="resposta.questao.tipo === 'Inteiro'"
            :id="resposta.questao._id"
            :label="resposta.questao.enunciado"
            :label-sup="resposta.questao.obrigatorio ? '*' : ''"
            mascara="999999"
            :valor="resposta.resposta"
            @blur="aoAtualizarResposta(resposta, $event)"
          />
          <SelecionarGenerico
            v-else-if="resposta.questao.tipo === 'Sim/Não'"
            :id="resposta.questao._id"
            :label="resposta.questao.enunciado"
            :label-sup="resposta.questao.obrigatorio ? '*' : ''"
            :valores="[
              { _id: true, descricao: 'Sim' },
              { _id: false, descricao: 'Não' },
            ]"
            :valor="resposta.resposta"
            @atualizar="aoAtualizarResposta(resposta, $event)"
          />
          <div v-else-if="resposta.questao.tipo === 'Texto'" class="form-group">
            <label>
              {{ resposta.questao.enunciado }}
              <sup>{{ resposta.questao.obrigatorio ? '*' : '' }}</sup>
            </label>
            <Editor
              :value="resposta.resposta.replaceAll('\n', '<br />')"
              @input="aoAtualizarResposta(resposta, $event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="agendamentoAberto && !agendamentoAbertoAvaliacao">
      <div
        v-for="diario in diariosDaSessao"
        :key="diario._id"
        style="padding: 2px 8px; margin-bottom: 24px"
      >
        <div
          style="
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            padding-bottom: 5px;
            color: #525252;
            border-bottom: 1px solid #d4d4d4;
            gap: 4px;
          "
        >
          <div style="display: flex; flex-flow: column">
            <div
              ><strong>{{ diario.usuario.nome }}</strong>
              {{ dataDiario(diario.data) }}.</div
            >
            <span v-if="diario._agendamento">
              {{ diario._agendamento.unidade }}
              {{ diario._agendamento.especialidade }} em
              {{ dataAgendamento(diario._agendamento.data) }}.
            </span>
          </div>
          <div>
            <button
              data-test-id="button-excluirdiario-6"
              type="button"
              class="btn btn-xs btn-default"
              @click="excluirDiario(diario)"
            >
              <span class="fa fa-trash"></span> Remover
            </button>
            <button
              data-test-id="button-abrirdiario-7"
              type="button"
              class="btn btn-xs btn-default"
              @click="abrirDiario(diario)"
            >
              <span class="fa fa-edit"></span> Editar
            </button>
          </div>
        </div>
        <div style="padding: 12px 8px" v-html="diario.entrada"></div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import Editor from '@/componentes/formulario/Editor'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarGenerico from '@/componentes/formulario/SelecionarGenerico'
import SelecionarMultiploDominio from '@/componentes/formulario/SelecionarMultiploDominio'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import EvolucaoServico from '@/servicos/EvolucaoServico'
import ProntuarioServico from '@/servicos/ProntuarioServico'
import QuestionarioServico from '@/servicos/QuestionarioServico'

const questionarioServico = new QuestionarioServico()
const evolucaoServico = new EvolucaoServico()
const prontuarioServico = new ProntuarioServico()
const agendamentoServico = new AgendamentoServico()

export default {
  components: {
    CampoGenerico,
    Editor,
    SelecionarMultiploDominio,
    SelecionarData,
    SelecionarGenerico,
  },
  props: {
    especialidade: { type: String, required: true },
    paciente: { type: String, required: true },
    pacienteNome: { type: String, required: true },
    diarios: { type: Array, default: () => [] },
    guia: { type: String, default: '' },
    abrirAvaliacao: { type: Boolean, default: false },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  validations: {
    respostas: {
      required,
      $each: {
        resposta: {
          $each: {
            obrigatoriaSemValor(valorResposta, resposta) {
              if (resposta.questao.obrigatorio) {
                return !!valorResposta
              }
              return true
            },
          },
        },
      },
    },
  },
  data() {
    return {
      temRespostas: false,
      temQuestionario: false,
      questionario: null,
      guias: [],
      guiaAberta: null,
      agendamentos: [],
      datas: [],
      prontuarioId: null,
      respostas: [],
      maximoDePaginas: 4,
      paginaInicial: 0,
      agendamentoAberto: null,
      respostaHover: '',
      historicoDaRespostaAtual: [],
      diariosDaSessao: [],
    }
  },
  computed: {
    agendamentosPagina() {
      return this.agendamentos.slice(
        this.paginaInicial,
        this.paginaInicial + this.maximoDePaginas
      )
    },
    agendamentoAbertoAvaliacao() {
      if (this.agendamentoAberto) {
        const primeiroAgendamento =
          this.agendamentos[this.agendamentos.length - 1]

        if (primeiroAgendamento)
          return primeiroAgendamento._id === this.agendamentoAberto._id
      }

      return false
    },
  },
  watch: {
    diarios() {
      this.abrirSessao(this.agendamentoAberto)
    },
  },
  async created() {
    const { guias } = await evolucaoServico.recuperaGuiasPorEspecialidade(
      this.paciente,
      this.especialidade
    )
    this.guias = guias

    if (!this.guias.length) return

    if (this.guia) {
      const guia = this.guias.find((g) => g._id === this.guia)
      this.guiaAberta = guia
    } else {
      this.guiaAberta = this.guias[0]
    }

    this.abrirGuia()
  },
  async mounted() {
    this.calcularMaximoDePaginas()
    window.addEventListener('resize', this.calcularMaximoDePaginas)
  },
  destroyed() {
    window.removeEventListener('resize', this.calcularMaximoDePaginas)
  },
  methods: {
    calcularMaximoDePaginas() {
      const tamanhoDaTela = window.innerWidth
      if (tamanhoDaTela > 1536) this.maximoDePaginas = 14
      else if (tamanhoDaTela > 1280) this.maximoDePaginas = 12
      else if (tamanhoDaTela > 1024) this.maximoDePaginas = 10
      else if (tamanhoDaTela > 768) this.maximoDePaginas = 8
      else if (tamanhoDaTela > 640) this.maximoDePaginas = 6
      else this.maximoDePaginas = 4
    },
    abrirSessao(agendamento) {
      this.agendamentoAberto = agendamento

      const primeiroAgendamento =
        this.agendamentos[this.agendamentos.length - 1]

      if (!primeiroAgendamento) return

      if (primeiroAgendamento._id === agendamento._id) {
        this.abrirRespostasAgendamento(agendamento)
      } else {
        this.abrirDiariosDaSessao(agendamento)
      }
    },
    async abrirRespostasAgendamento(agendamento) {
      const { respostas, _id: prontuarioId } =
        await evolucaoServico.recuperarRespostas(agendamento._id)
      this.respostas = respostas
      this.prontuarioId = prontuarioId
      this.temRespostas = !!respostas.length
      const { questionarios } = await questionarioServico.recuperarTodos({
        especialidade: this.especialidade,
        avaliacao: !!agendamento.avaliacao,
        ativo: true,
      })
      this.temQuestionario = !!questionarios[0]
      this.questionario = questionarios[0]
      this.processarRespostas()
    },
    abrirDiariosDaSessao() {
      this.diariosDaSessao = this.diarios.filter(
        (d) => d.agendamento === this.agendamentoAberto._id
      )
    },
    processarRespostas() {
      const respostasOriginais = this.respostas.flat() || []

      this.respostas = []

      if (!this.questionario) return

      this.questionario.questoes
        .map((questao) => {
          return questao.reduce((a, c) => {
            a.push({
              questao: c,
              resposta: c.respostaPadrao,
              dataResposta: moment.utc().format(),
              usuario: this.usuario,
              tipo: c.tipo,
            })
            return a
          }, [])
        })
        .forEach((w) => {
          if (respostasOriginais.length) {
            w.forEach((r) => {
              var respostaIndex = respostasOriginais.findIndex(
                (resp) => resp.questao._id === r.questao._id
              )

              if (~respostaIndex) {
                const resposta = respostasOriginais[respostaIndex]
                r.resposta = resposta.resposta
                r.respostaId = resposta._id
                respostasOriginais.splice(respostaIndex, 1)
              }
            })
          }

          this.respostas.push(w)
        })
    },
    aoAtualizarResposta(resposta, valor) {
      if (valor) {
        if (resposta.tipo === 'Inteiro') {
          valor = valor.value
        }
        resposta.resposta = valor
        resposta.dataResposta = moment.utc().format()
        resposta.usuario = this.usuario
      }
    },
    processaValorResposta(valor) {
      if (valor === 'true') return 'Sim'
      else if (valor === 'false') return 'Não'
      else if (moment.utc(valor, moment.ISO_8601, true).isValid())
        return moment.utc(valor).format('DD/MM/YYYY')
      return valor
    },
    abrirGuia() {
      this.agendamentoAberto = null
      this.agendamentos = []

      const agendamentosDaGuia = [...new Set(this.guiaAberta.agendamentos)]
      agendamentosDaGuia.forEach(async (agendamentoId, index) => {
        const { agendamento } =
          await agendamentoServico.recuperarAgendamento(agendamentoId)

        if (agendamento.ativo) {
          this.agendamentos.push({
            _id: agendamento._id,
            data: agendamento.data,
            hora: agendamento.hora,
            guia: agendamento.guia,
          })

          this.agendamentos.sort((a, b) => {
            if (a.data === b.data) {
              return a.hora.localeCompare(b.hora)
            }
            return b.data > a.data ? 1 : -1
          })
        }

        if (index === 0) this.abrirSessao(this.agendamentos[0])

        if (this.abrirAvaliacao) {
          this.abrirSessao(this.agendamentos.at(-1))
          this.paginaInicial = this.agendamentos.length - this.maximoDePaginas
        }
      })
    },
    async salvarVoltarAgendamento() {
      await this.salvar()
      await this.voltarAgendamento()
    },
    async salvar() {
      if (
        !this.prontuarioId ||
        this.prontuarioId === '000000000000000000000000'
      ) {
        const { prontuario } = await evolucaoServico.adicionarProntuario({
          paciente: { _id: this.paciente, nome: this.pacienteNome },
          dataInicio: moment.utc().toISOString(),
          questionario: this.questionario,
          guias: this.guias,
          agendamentos: this.agendamentoAberto._id,
        })
        this.prontuarioId = prontuario._id
      }
      await prontuarioServico.atualizar(this.prontuarioId, {
        respostas: this.respostas,
      })

      const { agendamento } = await agendamentoServico.recuperarAgendamento(
        this.agendamentoAberto._id
      )

      if (agendamento.status === 'assinado') {
        await agendamentoServico.atualizarAgendamentoEvoluido(
          this.agendamentoAberto
        )
      }
    },
    async voltarAgendamento() {
      const {
        agendamento: { unidade, especialidade, data },
      } = await agendamentoServico.recuperarAgendamento(
        this.agendamentoAberto._id
      )
      const formularioCache = JSON.parse(
        window.localStorage.getItem('tu.formularioCache')
      )
      const agendamentosFiltroForm = {
        unidade,
        especialidade,
        dia: moment.utc(data).format('DD/MM/YYYY'),
      }
      window.localStorage.setItem(
        'tu.formularioCache',
        JSON.stringify({ ...formularioCache, agendamentosFiltroForm })
      )
      this.$router.replace({ name: 'Agendamento' })
    },
    dataAgendamento(data) {
      return moment.utc(data).startOf('day').format('MMM DD, YYYY')
    },
    dataDiario(data) {
      const dataFormatada = moment
        .utc(data)
        .startOf('day')
        .format('MMM DD, YYYY')
      if (moment.utc(data).startOf('day').isSame(moment.utc().startOf('day')))
        return `hoje (${dataFormatada})`
      return `${moment
        .utc()
        .startOf('day')
        .to(moment.utc(data).startOf('day'))} (${dataFormatada})`
    },
    abrirDiarioModal() {
      this.$emit('selecionarDiario', {
        _id: null,
        entrada: '',
        data: moment.utc().toDate(),
        especialidade: this.especialidade,
        agendamento: this.agendamentoAberto._id,
      })
      document.querySelector('#diarioForm').showModal()
    },
    abrirDiario(diario) {
      this.$emit('selecionarDiario', diario)
      document.querySelector('#diarioForm').showModal()
    },
    excluirDiario(diario) {
      this.$emit('excluirDiario', diario)
    },
    moment: moment.utc,
  },
}
</script>

<style scoped>
.prontuario-resposta {
  position: relative;
}

.prontuario-respostas .prontuario-respostas-grupo {
  display: flex;
  flex-flow: row wrap;
  padding: 26px 0 64px 8px;
}

.prontuario-respostas .prontuario-resposta {
  flex: 1 1 auto;
  margin: 0 16px;
}
.prontuario-form .btn {
  width: auto;
}

.prontuario-content {
  min-height: 180px;
}

.prontuario-bottom {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
}

.botoes {
  position: sticky;
  top: 60px;
  right: 0;
  z-index: 200;
  display: flex;
  justify-content: flex-end;
  margin: 12px 0;
  gap: 4px;
}
</style>
